import React from "react";

const Spinner = () => (
  <svg
    className="animate-spin h-4 w-4"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24">
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
  </svg>
);

/**
 * Reusable section: label + email input + Fetch User button.
 */
export default function UserFetchSection({
  title,
  icon: Icon,
  label,
  value,
  onChange,
  onFetch,
  loading,
  placeholder = "e.g., user@example.com",
}) {
  const disabled = loading || !value?.trim();

  return (
    <div className="bg-white p-4 sm:p-5 md:p-6 rounded-xl sm:rounded-2xl border-2 border-red-200 shadow-lg min-w-0">
      <h2 className="text-lg sm:text-xl md:text-2xl font-bold mb-3 sm:mb-4 text-gray-800 flex items-center gap-2">
        <span className="bg-red-500 text-white p-1.5 sm:p-2 rounded-lg border-2 border-red-500 flex-shrink-0">
          {Icon && <Icon className="text-white text-sm sm:text-base" />}
        </span>
        <span className="text-base sm:text-lg md:text-xl truncate">{title}</span>
      </h2>
      <div className="space-y-3 sm:space-y-4">
        <div>
          <label className="block text-xs sm:text-sm font-semibold mb-2 text-gray-700">
            {label}
          </label>
          <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
            <input
              type="email"
              value={value}
              onChange={(e) => onChange(e.target.value)}
              placeholder={placeholder}
              className="flex-1 min-w-0 p-2.5 sm:p-3 text-sm sm:text-base border-2 border-gray-300 rounded-lg sm:rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
              disabled={loading}
            />
            <button
              type="button"
              onClick={onFetch}
              disabled={disabled}
              className={`w-full sm:w-auto px-4 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base bg-gradient-to-r from-red-500 to-red-600 text-white rounded-lg sm:rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-2 ${
                disabled ? "opacity-50 cursor-not-allowed" : "hover:scale-[1.02] active:scale-[0.98]"
              }`}>
              {loading ? (
                <>
                  <Spinner />
                  <span className="hidden sm:inline">Fetching...</span>
                  <span className="sm:hidden">...</span>
                </>
              ) : (
                "Fetch User"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
